<template>
  <section
    class="octadesk-proactive-msg-wrapper"
    :class="`octadesk-msg-window--${settings.position}`"
  >
    <div
      v-if="
        flux.message.sender &&
        flux.message.sender.id &&
        flux.message.sender.thumbUrl
      "
      class="octadesk-app-avatar circulo"
    >
      <img
        v-if="flux.message.sender.thumbUrl"
        :src="flux.message.sender.thumbUrl.replace('http:', 'https:')"
        :title="flux.message.sender.name"
        :alt="flux.message.sender.name"
      />

      <div
        v-else
        class="octadesk-msg-disc"
        :style="`background-color: rgba(${settings.bgColorRGB}, 1)`"
      >
        <p
          :style="`color: rgba(${settings.fontColorRGBA});`"
          v-text="flux.message.sender.name[0]"
        ></p>
      </div>
    </div>

    <div
      ref="proactiveMsg"
      class="octadesk-proactive-msg"
      @click="handleOpenMsg"
    >
      <p
        v-if="flux.message.sender && flux.message.sender.id"
        class="sender-info-text"
      >
        {{ flux.message.sender.name }}
        {{
          flux.message.sender.organization
            ? `| ${flux.message.sender.organization.name}`
            : ''
        }}
      </p>

      <span class="proactive-msg-comment" v-html="comment"></span>
    </div>

    <span
      class="icon-close proactive-close-btn"
      @click="manualCloseProactiveMessage"
    ></span>
  </section>
</template>

<script>
  import { parseHTML } from '@/helpers'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['flux', 'settings', 'user']),
      comment() {
        if (this.flux && this.user) {
          return this.$sanitizeHtml(
            parseHTML(this.flux.message.comment, this.user)
          )
        } else if (this.flux) {
          return this.$sanitizeHtml(this.flux.message.comment)
        }
        return ''
      }
    },
    mounted() {
      if (this.$refs.proactiveMsg) {
        const msgHeight = this.$refs.proactiveMsg.clientHeight

        const updatedStyles = `height: ${msgHeight + 98}px !important;`

        this.changeIframeStyles(updatedStyles)
      }
    },
    methods: {
      ...mapActions([
        'toggleApp',
        'openProactiveMsg',
        'manualCloseProactiveMessage',
        'changeIframeStyles'
      ]),
      handleOpenMsg() {
        this.openProactiveMsg(this.flux.id)
          .then(() => this.toggleApp())
          .catch(() => this.toggleApp())
      }
    }
  }
</script>

<style scoped lang="scss">
  section.octadesk-proactive-msg-wrapper {
    position: absolute;
    max-width: 100%;
    div.octadesk-app-avatar.circulo {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      position: relative;
      border-radius: 100%;
      display: inline-block;
    }
    div.octadesk-msg-disc {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      text-align: center;
      padding-top: 2px;
    }
    div.octadesk-proactive-msg {
      display: inline-block;
      position: relative;
      overflow-y: auto;
      background-color: #f5f5f5;
      width: 295px;
      max-height: 500px;
      min-height: 100px;
      border: 1px solid #ddd;
      padding: 12px;
      cursor: pointer;
      border-radius: 0.375rem;
      box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
        0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.4);
      z-index: 2147483647;
      -webkit-transition: max-width 0, max-height 0, opacity 0;
      transition: max-width 0, max-height 0, opacity 0;
      p.sender-info-text {
        font-size: 11px;
        margin: 0 !important;
        color: #aaa;
      }
      span.proactive-msg-comment {
        font-size: 12px;
        margin-top: 15px;
        display: inline-block;
        white-space: pre-wrap;
      }
      @media screen and (max-device-width: 767px) {
        width: 240px;
      }
    }
    span.proactive-close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 15px;
      height: 15px;
      z-index: 2147483648;
      color: #aaa;
      font-size: 10px;
      cursor: pointer;
    }
    &.octadesk-msg-window--topLeft {
      top: 5rem;
      left: 0.25rem;
      -webkit-transform-origin: left top;
      -ms-transform-origin: left top;
      transform-origin: left top;
      @media screen and (max-device-width: 767px) {
        left: 1.25rem;
      }
    }
    &.octadesk-msg-window--topRight {
      top: 5rem;
      right: 0.25rem;
      -webkit-transform-origin: right top;
      -ms-transform-origin: right top;
      transform-origin: right top;
      @media screen and (max-device-width: 767px) {
        right: 1.25rem;
      }
    }
    &.octadesk-msg-window--bottomLeft {
      bottom: 5.75rem;
      left: 0.25rem;
      -webkit-transform-origin: left bottom;
      -ms-transform-origin: left bottom;
      transform-origin: left bottom;
      @media screen and (max-device-width: 767px) {
        left: 1.25rem;
      }
    }
    &.octadesk-msg-window--bottomRight {
      bottom: 5.75rem;
      right: 0.25rem;
      -webkit-transform-origin: right bottom;
      -ms-transform-origin: right bottom;
      transform-origin: right bottom;
      @media screen and (max-device-width: 767px) {
        right: 1.25rem;
      }
    }
  }
</style>
